import { takeLatest, all, call, put } from "redux-saga/effects";
import { TRIGGER_ADS_LIST, requestedAds, adsError, adsOngoing } from "app/redux/features/ads";
import { makeRequest } from "../../utils/makeRequest";

function* getProposalRequestListDraft({ payload }: any): Generator<any, void, any> {
  try {
    yield put(adsOngoing());
    const { path, key, isRequestParams, isQueryParams } = payload;
    const response = yield call(() => makeRequest(path).get(key, isRequestParams, isQueryParams));
    yield put(requestedAds(response.data));
  } catch (error: any) {
    yield put(adsError(error));
  }
}

export default function* adsSaga() {
  yield all([takeLatest(TRIGGER_ADS_LIST, getProposalRequestListDraft)]);
}
